
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class ReportRecvbyCashierbyDateDialog extends Serenity.EntityDialog<ReportRecvbyCashierbyDateRow, any> {
        protected getFormKey() { return ReportRecvbyCashierbyDateForm.formKey; }
        protected getIdProperty() { return ReportRecvbyCashierbyDateRow.idProperty; }
        protected getLocalTextPrefix() { return ReportRecvbyCashierbyDateRow.localTextPrefix; }
        protected getNameProperty() { return ReportRecvbyCashierbyDateRow.nameProperty; }
        protected getService() { return ReportRecvbyCashierbyDateService.baseUrl; }
        protected getDeletePermission() { return ReportRecvbyCashierbyDateRow.deletePermission; }
        protected getInsertPermission() { return ReportRecvbyCashierbyDateRow.insertPermission; }
        protected getUpdatePermission() { return ReportRecvbyCashierbyDateRow.updatePermission; }

        protected form = new ReportRecvbyCashierbyDateForm(this.idPrefix);

    }
}